<template>
  <div class="queryform">
    <form class="uk-form-stacked">
      <div class="uk-margin">
        <label class="uk-form-label" for="form-from-date">Data inizio</label>
        <div class="uk-form-controls">
          <input class="uk-input uk-form-width-small" id="form-from-date" type="date" v-model="fromDate" v-on:blur="onChange">
          <input class="uk-input uk-form-width-small" id="form-from-time" type="time" v-model="fromTime" v-on:blur="onChange">
        </div>
      </div>
      <div class="uk-margin">
        <label class="uk-form-label" for="form-to-date">Data fine</label>
        <div class="uk-form-controls">
          <input class="uk-input uk-form-width-small" id="form-to-date" type="date" v-model="toDate" v-on:blur="onChange">
          <input class="uk-input uk-form-width-small" id="form-to-time" type="time" v-model="toTime" v-on:blur="onChange">
        </div>
      </div>
      <div class="uk-margin" v-if="showQuickFilters != null && showQuickFilters == true">
        <vk-button size="small">Filtri rapidi <vk-icon icon="chevron-right"></vk-icon></vk-button>
        <vk-dropdown>
          <vk-nav-dropdown>
            <vk-nav-item title="Ultima ora" v-on:click="shortcutLast(3600 * 1)"></vk-nav-item>
            <vk-nav-item title="Ultime 6 ore" v-on:click="shortcutLast(3600 * 6)"></vk-nav-item>
            <vk-nav-item title="Ultimo giorno" v-on:click="shortcutLast(3600 * 24)"></vk-nav-item>
            <vk-nav-item title="Ultima settimana" v-on:click="shortcutLast(3600 * 24 * 7)"></vk-nav-item>
          </vk-nav-dropdown>
        </vk-dropdown>
      </div>
      <div class="uk-margin">
        <label class="uk-form-label" for="form-from-date">
          Filtra devices
          <a v-if="devices.length > 0" href="javascript:void(0);" @click="selectAll" class="action-link">
            [tutti]
          </a>
          <a v-if="devices.length > 0" href="javascript:void(0);" @click="deselectAll" class="action-link">
            [nessuno]
          </a>
        </label>
        <div v-if="devices.length <= 0"><i>(nessun device assegnato)</i></div>
        <template v-for="device in devices">
          <span v-bind:key="device.id">
            <input v-model="deviceFilter" class="uk-checkbox" :value="device.id" type="checkbox" @change="onChange"> {{ device.label }}
            <br>
          </span>
        </template>
      </div>
    </form>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'QueryForm',

  data () {
    const timeFilter = this.timeFilterToLast(3600 * 24)

    return {
      devices: [],
      deviceFilter: [],
      ...timeFilter
    }
  },

  created () {
    // this.$store.dispatch('REFRESH_USER_DEVICES', this.$http)
    this.updateUserDevicesList(this.$store.state.userDevices)

    // load last query parameters from shared state in store
    if (
      this.$store.state.queryLastParam.from != null &&
      this.$store.state.queryLastParam.to != null
    ) {
      const timeFilter = this.timeFilterFromTimestamps(
        this.$store.state.queryLastParam.from * 1000,
        this.$store.state.queryLastParam.to * 1000
      )

      this.deviceFilter = this.$store.state.queryLastParam.deviceFilter
      this.fromDate = timeFilter.fromDate
      this.fromTime = timeFilter.fromTime
      this.toDate = timeFilter.toDate
      this.toTime = timeFilter.toTime

      this.onChange()
    }
  },

  props: ['showQuickFilters', 'defaultNoneSelected'],

  computed: mapState(['userDevices']),

  watch: {
    userDevices (newValue) {
      this.updateUserDevicesList(newValue)
    }
  },

  methods: {
    updateUserDevicesList (userDevices) {
      this.devices = userDevices.map((device) => {
        return { id: device.id, label: device.label }
      })

      if (this.$store.state.isAdmin == true || (this.defaultNoneSelected != null && this.defaultNoneSelected == true)) {
        this.deselectAll()
      } else {
        this.selectAll()
      }

      this.onChange()
    },

    onChange () {
      const fromTimeStr = this.fromTime == "" ? "00:00" : this.fromTime
      const toTimeStr = this.toTime == "" ? "23:59" : this.toTime

      const from = Date.parse(this.fromDate + " " + fromTimeStr) / 1000
      const to = Date.parse(this.toDate + " " + toTimeStr) / 1000

      this.$emit('input', {
        from: from,
        to: to,
        deviceFilter: this.deviceFilter
      })
    },

    timeFilterToLast (seconds) {
      const toTimestamp = Date.now()
      const fromTimestamp = toTimestamp - (seconds * 1000)

      return {
        fromDate: new Date(fromTimestamp).toISOString().substr(0, 10),
        toDate: new Date(toTimestamp).toISOString().substr(0, 10),
        fromTime: new Date(fromTimestamp).toTimeString().substr(0, 5),
        toTime: "23:59"
      }
    },

    timeFilterFromTimestamps (from, to) {
      return {
        fromDate: new Date(from).toISOString().substr(0, 10),
        toDate: new Date(to).toISOString().substr(0, 10),
        fromTime: new Date(from).toTimeString().substr(0, 5),
        toTime: new Date(to).toTimeString().substr(0, 5),
      }
    },

    shortcutLast (seconds) {
      const filter = this.timeFilterToLast(seconds)

      this.fromDate = filter.fromDate
      this.fromTime = filter.fromTime
      this.toDate = filter.toDate
      this.toTime = filter.toTime

      this.onChange()
    },

    selectAll () {
      console.log("selecting all")

      this.deviceFilter = []
      this.devices.forEach((dev) => {
        this.deviceFilter.push(dev.id)
      })

      this.onChange()
    },

    deselectAll () {
      console.log("deselecting all")

      this.deviceFilter = []

      this.onChange()
    }
  }
}
</script>

<style lang="scss" scoped>
  .queryform {
    padding: 0em;
    text-align: left;
  }

  .action-link {
    color: #1e87f0 !important;
  }

  .action-link :visited {
    color: #1e87f0 !important;
  }
</style>
